import cookie from 'js-cookie'

export function clearCookie() {
  cookie.remove('openId')
  cookie.remove('id')
  cookie.remove('fullName')
  cookie.remove('username')
  cookie.remove('showPrompt')
  cookie.remove('stationId')
  cookie.remove('stationName')
  cookie.remove('tempTabLabel')
  cookie.remove('stationDirector')
  cookie.remove('hadDirector')
}

export function MapGender(gender) {
  if (gender === "MALE") {
    return "男";
  } else if (gender === "FEMALE") {
    return "女";
  } else if (gender === "男") {
    return "MALE";
  } else if (gender === "女") {
    return "FEMALE";
  } else {
    return "--";
  }
}
export function MapEmployeeRoles(role) {
  switch (role) {
    case "ROLE_AGENT_OPTOMETRIST":
      return "视觉训练师";
    case "ROLE_DOCTOR":
      return "医生";
    case "ROLE_STATION_MANAGER":
      return "主管"
    default:
      return undefined
  }
}
export function MapRoles(roles) {
  switch (roles) {
    case "ROLE_REGION_MANAGER":
      return "大区经理";
    case "ROLE_SUPER_ADMIN":
      return "超级管理员";
    case "ROLE_ADMIN":
      return "管理员";
    case "ROLE_GROUP_OPTOMETRIST":
      return "广目视觉训练师";
    case "ROLE_AGENT_OPTOMETRIST":
      return "视觉训练师";
    case "ROLE_DOCTOR":
      return "医生";
    case "ROLE_AGENT":
      return "代理商";
    case "ROLE_SALESMAN":
      return "销售"
    case "ROLE_AGENT_FINANCIAL":
      return "代理商财务"
    case "ROLE_STATION_MANAGER":
      return "主管"
    case "大区经理":
      return "ROLE_REGION_MANAGER";
    case "超级管理员":
      return "ROLE_SUPER_ADMIN";
    case "管理员":
      return "ROLE_ADMIN";
    case "广目视觉训练师":
      return "ROLE_GROUP_OPTOMETRIST";
    case "视觉训练师":
      return "ROLE_AGENT_OPTOMETRIST";
    case "医生":
      return "ROLE_DOCTOR";
    case "代理商":
      return "ROLE_AGENT";
    case "销售":
      return "ROLE_SALESMAN"
    case "代理商财务":
      return "ROLE_AGENT_FINANCIAL"
    case "主管":
      return "ROLE_STATION_MANAGER"
    default:
      return "--";
  }
}

export function MapAgentAuth(auth) {
  if (auth === "ROLE_DATA_MONITOR") {
    return '统计数据'
  } else if (auth === "ROLE_SALESMAN") {
    return '开单'
  } else return null
}

export function MapTrackState(auth) {
  if (auth === "NEED_REVIEW") {
    return '未处理'
  } else if (auth === "REVIEWED") {
    return '已处理'
  } else return null
}

export function MapAgentStationStatus(auth) {
  if (auth === "APPLYING") {
    return '审核中'
  } else if (auth === "APPROVED") {
    return '已核准'
  } else if (auth === "REFUSED") {
    return '已拒绝'
  } else return null
}

export function MapVisionDisease(type) {
  if (type === "AMBLYOPIA") {
    return '弱视'
  } else if (type === "STRABISMUS") {
    return '斜视'
  } else {
    return '其他'
  }
}

export function MapPaymentOperation(type) {
  if (type === "REFUND") {
    return '退货'
  } else if (type === "PAY") {
    return '进货'
  } else {
    return '--'
  }
}

export function calcTotalScore(arr) {
  if (arr.length <= 0) {
    return 0
  } else {

  }
}

export function MapEyeType(str) {
  if (str === "SIMULTANEOUS_PERCEPTION") {
    return '同时视'
  } else if (str === "AMBLYOPIA_DISINHIBITION") {
    return '弱视脱抑制'
  } else if (str === "STRABISMUS_DISINHIBITION") {
    return '斜视脱抑制'
  } else if (str === "LEFT") {
    return '左眼'
  } else if (str === "RIGHT") {
    return '右眼'
  } else if (str === "BINOCULAR_SIMULTANEOUS") {
    return '双眼同时'
  } else if (str === "SEPARATION") {
    return '左右眼分开'
  } else if (str === "CENTRAL_FIXATION") {
    return '中心注视'
  } else if (str === "EC_CENTRAL_FIXATION") {
    return '旁中心注视'
  } else if (str === "NYSTAGMUS") {
    return '眼球震颤'
  } else {
    return ''
  }
}

export function GetDoctorAdvice(str) {
  if (str === "LEFT") {
    return [{
        list: ['如有矫正眼镜，训练时请戴上眼镜',
          '请遮盖右眼，只用左眼训练10分钟，系统自动计时',
          '非训练时间是否需要遮盖及遮盖比例，请遵循医嘱要求',
          '如果训练提示戴上红蓝眼镜，双眼同时训练',
        ],
        type: '视力+视功能'
      },
      {
        list: [
          '如有矫正眼镜，训练时请戴上眼镜',
          '请遮盖右眼，只用左眼训练10分钟，系统自动计时',
          '非训练时间是否需要遮盖及遮盖比例，请遵循医嘱要求',
        ],
        type: '视力'
      },
    ]
  } else if (str === "RIGHT") {
    return [{
        list: ['如有矫正眼镜，训练时请戴上眼镜',
          '请遮盖左眼，只用右眼训练10分钟，系统自动计时',
          '非训练时间是否需要遮盖及遮盖比例，请遵循医嘱要求',
          '如果训练提示戴上红蓝眼镜，双眼同时训练'
        ],
        type: '视力+视功能'
      },
      {
        list: [
          '如有矫正眼镜，训练时请戴上眼镜',
          '请遮盖左眼，只用右眼训练10分钟，系统自动计时',
          '非训练时间是否需要遮盖及遮盖比例，请遵循医嘱要求',
        ],
        type: '视力'
      },
    ]
  } else if (str === "BINOCULAR_SIMULTANEOUS") {
    return [{
        list: ['如有矫正眼镜，训练时请戴上眼镜',
          '训练时不用遮盖，双眼同时训练10分钟，系统自动计时',
          '非训练时间是否需要遮盖及遮盖比例，请遵循医嘱要求',

        ],
        type: '视力+视功能'
      },
      {
        list: [
          '如有矫正眼镜，训练时请戴上眼镜',
          '双眼同时训练10分钟，系统自动计时'
        ],
        type: '视功能'
      },
    ]
  } else if (str === "SEPARATION") {
    return [{
        list: ['如有矫正眼镜，训练时请戴上眼镜',
          '请遮盖左眼，训练右眼10分钟，再遮盖右眼，训练左眼10分钟',
          '非训练时间是否需要遮盖及遮盖比例，请遵循医嘱要求',
        ],
        type: '视力'
      },

    ]
  }
}

export function MapGameLabel(str) {
  if (str === "精细刺激训练") {
    return 'FINE_STIMULATION_TRAINING'
  } else if (str === "视觉技巧训练") {
    return 'VISUAL_SKILL_TRAINING'
  } else if (str === "同时视") {
    return 'SAME_TIME_BINOCULAR_VISION_TRAINING'
  } else if (str === "融合视") {
    return 'FUSION_VISION_BINOCULAR_VISION_TRAINING'
  } else if (str === "立体视") {
    return 'STEREOSCOPIC_BINOCULAR_VISION_TRAINING'
  } else if (str === "Gabor训练") {
    return 'GABOR_TRAINING'
  } else if (str === "对比敏感度训练") {
    return 'CONTRAST_SENSITIVITY_TRAINING'
  } else if (str = "信息提取训练") {
    return 'INFORMATION_EXTRACTION_TRAINING'
  }
}

export function MapEeyVersion(value) {
  if (value == "0.01") {
    return "0.01(3.0)"
  } else if (value == "0.012") {
    return "0.012(3.1)"
  } else if (value == "0.015") {
    return "0.015(3.2)"
  } else if (value == "0.02") {
    return "0.02(3.3)"
  } else if (value == "0.025") {
    return "0.025(3.4)"
  } else if (value == "0.03") {
    return "0.03(3.5)"
  } else if (value == "0.04") {
    return "0.04(3.6)"
  } else if (value == "0.05") {
    return "0.05(3.7)"
  } else if (value == "0.06") {
    return "0.06(3.8)"
  } else if (value == "0.08") {
    return "0.08(3.9)"
  } else if (value == "0.1") {
    return "0.1(4.0)"
  } else if (value == "0.125") {
    return "0.125(4.1)"
  } else if (value == "0.15") {
    return "0.15(4.2)"
  } else if (value == "0.2") {
    return "0.2(4.3)"
  } else if (value == "0.25") {
    return "0.25(4.4)"
  } else if (value == "0.3") {
    return "0.3(4.5)"
  } else if (value == "0.4") {
    return "0.4(4.6)"
  } else if (value == "0.5") {
    return "0.5(4.7)"
  } else if (value == "0.6") {
    return "0.6(4.8)"
  } else if (value == "0.7") {
    return "0.7"
  } else if (value == "0.8") {
    return "0.8(4.9)"
  } else if (value == "0.9") {
    return "0.9"
  } else if (value == "1.0") {
    return "1.0(5.0)"
  } else if (value == "1.2") {
    return "1.2(5.1)"
  } else if (value == "1.5") {
    return "1.5(5.2)"
  } else if (value == "2.0") {
    return "2.0(5.3)"
  } else {
    return ''
  }
}

export function MapEyeAcuityLogmar(value) {
  if (value == "0.01") {
    return "0.01"
  } else if (value == "0.012") {
    return "0.012"
  } else if (value == "0.015") {
    return "0.015"
  } else if (value == "0.02") {
    return "0.02"
  } else if (value == "0.025") {
    return "0.025"
  } else if (value == "0.03") {
    return "0.03"
  } else if (value == "0.04") {
    return "0.04"
  } else if (value == "0.05") {
    return "0.05"
  } else if (value == "0.06") {
    return "0.06"
  } else if (value == "0.08") {
    return "0.08"
  } else if (value == "0.1") {
    return "0.1"
  } else if (value == "0.125") {
    return "0.125"
  } else if (value == "0.15") {
    return "0.15"
  } else if (value == "0.2") {
    return "0.2"
  } else if (value == "0.25") {
    return "0.25"
  } else if (value == "0.3") {
    return "0.3"
  } else if (value == "0.4") {
    return "0.4"
  } else if (value == "0.5") {
    return "0.5"
  } else if (value == "0.6") {
    return "0.6"
  } else if (value == "0.7") {
    return "0.7"
  } else if (value == "0.8") {
    return "0.8"
  } else if (value == "0.9") {
    return "0.9"
  } else if (value == "1.0") {
    return "1.0"
  } else if (value == "1.2") {
    return "1.2"
  } else if (value == "1.5") {
    return "1.5"
  } else if (value == "2.0") {
    return "2.0"
  } else {
    return ''
  }
}

export function MapRefundStatus(type) {
  if (type === "PATIENT_REVIEW") {
    return '患者审核'
  } else if (type === "PATIENT_REFUSED") {
    return '患者拒绝'
  } else if (type === "REGION_REVIEW") {
    return '大区经理审核'
  } else if (type === "REGION_REFUSED") {
    return '大区经理拒绝'
  } else if (type === "PASSED") {
    return '已通过'
  } else {
    return '--'
  }
}

export function MapClientType(type) {
  if (type === "ANDROID_PAD") {
    return '安卓平板';
  } else if (type === "IPAD") {
    return '苹果平板';
  } else if (type === "WINDOWS_PAD") {
    return 'windows平板';
  } else if (type === "WINDOWS_CLIENT") {
    return 'windows客户端';
  } else if (type === "WINDOWS_WEB") {
    return 'windows网页端';
  } else if (type === "MAC_CLIENT") {
    return '苹果客户端';
  } else if (type === "MAC_WEB") {
    return '苹果网页端';
  } else if (type === "WEB") {
    return '未知网页端';
  } else if (type === "CLIENT") {
    return '未知客户端';
  } else {
    return '--';
  }
}

export function MapTreatmentStage(type) {
  if (type === "PROMOTE") {
    return "提升期";
  } else if (type === "CONSOLIDATION") {
    return "巩固期";
  } else if (type === "UNKNOWN") {
    return "未知";
  } else {
    return "--";
  }
}


// WEBPACK FOOTER //
// ./src/common/util.js